// extracted by mini-css-extract-plugin
export default {"howToPlay":"rules_howToPlay__7hE-d","howToPlayActive":"rules_howToPlayActive__-KJGA","rulesContent":"rules_rulesContent__RWGMH"};